import React from "react";

import { SmartFormRadioGroup } from "@mui-styled-components/SmartFormElements";

export type DesignToolT = "vision" | "aurora";

export type DesignToolSelectorPropsT = {
  name: string;
  auroraNonRequestableReason: string | null;
  disabled?: boolean;
};

const AURORA_TOOLTIPS: Record<string, string> = {
  outside_aurora_regions: "Aurora is not available in this project's state",
  qualify_incomplete: "Qualify this project to unlock Aurora",
  aurora_in_progress: "An Aurora request is already in progress for this project",
};

const GENERIC_AURORA_TOOLTIP = "Aurora is not available for this project";

const DesignToolSelector = ({ name, auroraNonRequestableReason, disabled = false }: DesignToolSelectorPropsT) => {
  const isAuroraDisabled = !!auroraNonRequestableReason;

  return (
    <SmartFormRadioGroup
      name={name}
      row
      disabled={disabled}
      radioOptions={[
        { label: "Vision", value: "vision" },
        {
          label: "Aurora",
          value: "aurora",
          optionDisabled: isAuroraDisabled,
          ...(isAuroraDisabled && {
            tooltipText: AURORA_TOOLTIPS[auroraNonRequestableReason as string] || GENERIC_AURORA_TOOLTIP,
          }),
        },
      ]}
      radioLabelStyle={{ marginLeft: "-2px", marginRight: "14px" }}
    />
  );
};

export default DesignToolSelector;
